import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { DateInfo } from "@/core/constants/dateInfo";
import { imgPhoneBgLock } from "@/shared/assets/img";
import { Lock4Icon } from "@/shared/icons";
import PhoneHeader from "@/domains/phone/components/PhoneHeader";

type Props = {
  isLock: boolean;
  currentTime: DateInfo;
  onClick: () => void;
};

export default function PhoneLockScreen({ isLock, currentTime, onClick }: Props) {
  const { month, day, hours, minutes, weekday } = currentTime;
  const { t } = useTranslation("phone");

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <AnimatePresence>
      {isLock && (
        <motion.div
          className="absolute z-10 top-0 left-0 flex flex-wrap size-full bg-no-repeat bg-cover"
          style={{
            backgroundImage: `url(${imgPhoneBgLock})`,
          }}
          onClick={onClick}
          initial={{ y: 0 }}
          animate={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.35, ease: "easeInOut" }}
        >
          <div className="w-full">
            <PhoneHeader hours={hours} minutes={minutes} />
            <div className="flex flex-col items-center w-full">
              <Lock4Icon className="size-6" />
              <p className="text-[4rem]">
                {hours}:{minutes}
              </p>
              <p className="text-18">
                {t(`phone.days.${weekday}`)}, {day} {t(`phone.months.${month}`)}
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center gap-7.5 mt-auto mb-2.5 mx-auto">
            <p className="max-w-60 text-14 text-center">{t("phone.touchToLockScreen")}</p>
            <div className="w-25 h-1 bg-white rounded" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
